import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConnectedPage } from './connected-page';
import { ConstantsModule } from '../constants/constants.module';
import { CookieService } from 'ngx-cookie-service';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';

export class DialogPage  extends ConnectedPage {
	// Parent for all dialog pages.

	constructor(constantsModule: ConstantsModule, cookieService: CookieService, httpClient: HttpClient, router: Router, modalService: NgbModal, private _modalInstance: NgbActiveModal) {
		super(constantsModule, cookieService, httpClient, router, modalService);
	}

	// Getters.
	protected get modalInstance() {
		return this._modalInstance;
	}

	// Default modal handling.
	public cancelDialog() {
		// Close the current dialog.
		this._modalInstance.close("FERMETURE");
	}
}
